import React, {useState, useEffect, useContext} from 'react';
import './ReportSettori.css';
import CircleProgress from '../../../../components/CircleProgress/CircleProgress';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { 
    DataGridPremium,
    LicenseInfo,
    GridColDef,
    GridRowModel,
	GRID_TREE_DATA_GROUPING_FIELD,
	DataGridPremiumProps,
	GridRenderCellParams,
	useGridApiContext,
	useGridSelector,
	gridFilteredDescendantCountLookupSelector,  GridToolbarContainer,
	GridToolbarExport,
} from '@mui/x-data-grid-premium';
import NoRowsDataGridComponent from '../../../../components/NoRowsDataGridComponent/NoRowsDataGridComponent';
import axios from 'axios';
import config from '../../../../config';
import { AuthContext } from '../../../../contexts/authContext';
import { NotificationManager } from 'react-notifications';
import { formatNumbersIt, getFormatDateFromDate, inputOnlyNumbers } from '../../../../utils/CommonUtilities';
import Button, { ButtonProps } from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { ArrowDown, ArrowRight } from '../../../../assets/icons/icons';
import { AppAuthGlobalVariables } from '../../../../contexts/AppAuthContext';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const columns:GridColDef[] = [
	{ field: 'CLIENTE', headerClassName: 'header-cell cliente', headerName: "Cliente", type: 'text', width: 200, editable: false},
	{ field: 'ACTUAL', headerClassName: 'header-cell actual', headerName: "Actual", type: 'number', width: 150, editable: false, description: 'Proposte Contrattualizzate, Contrattualizzate in Modifica e Chiuse su Data Fatturazione', align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'PY', headerClassName: 'header-cell py', headerName: "Anno Prec.", type: 'number', width: 150, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'DELTA_PY', headerClassName: 'header-cell deltaPy', headerName: "Δ Anno Prec.", type: 'number', width: 120, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' %' : '0 %'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'LEADS', headerClassName: 'header-cell leads', headerName: "Leads", type: 'number', width: 150, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'CONFERMATE', headerClassName: 'header-cell confermate', headerName: "Confermate", type: 'number', width: 150, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'RIFIUTATE_CA', headerClassName: 'header-cell rifiutate-ca', headerName: "Rifiutate CL/AG", type: 'number', width: 150, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'RIFIUTATE_TAL', headerClassName: 'header-cell rifiutate-tal', headerName: "Rifiutate Talent", type: 'number', width: 150, editable: false, align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}},
	{ field: 'TOTALE_PROPOSTE', headerClassName: 'header-cell totProposta', headerName: "Totale Proposte", type: 'number', width: 150, editable: false, description: 'Somma di Actual, Leads, Confermate, Rifiutate CL/AG e Rifiutate Talent', align: 'right', headerAlign: 'right', valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'}, valueGetter: (params) => {return !params?.value ? 0 : params.value}}
];

function CustomToolbar() {
    const { pageName } = useContext(AppAuthGlobalVariables);
	return (
		<GridToolbarContainer>
			<GridToolbarExport
				csvOptions = {{
					fileName: `${pageName?.toLowerCase()} - ${getFormatDateFromDate(new Date(), '_')}`,
					valueFormatter: (params:any) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) : '0'}
				}}
                excelOptions={{
                    fileName: `${pageName?.toLowerCase()} - ${getFormatDateFromDate(new Date(), '_')}`
                }}
				printOptions={{ disableToolbarButton: true }}
            />
		</GridToolbarContainer>
	);
}

function CustomGridTreeDataGroupingCell(props: GridRenderCellParams) {
	const { id, field, rowNode } = props;
	const apiRef = useGridApiContext();
	const filteredDescendantCountLookup = useGridSelector(
	  apiRef,
	  gridFilteredDescendantCountLookupSelector,
	);
	const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

	const handleClick: ButtonProps['onClick'] = (event) => {
	  if (rowNode.type !== 'group') {
		return;
	  }
  
	  apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
	  apiRef.current.setCellFocus(id, field);
	  event.stopPropagation();
	};
	//filteredDescendantCount serve per stabilire se il padre ha dei figli
	//quando il un cliente è padre di sè stesso non mostro la casella del child perché ridondante
	if(props.row.id===0){
		return null;
	}else{
		return (
			<div style={{display: 'flex', alignItems: 'center', width: '300px'}}>
				{rowNode.type === 'group' ?
					<>
						{/* {filteredDescendantCount > 1&&( */}
						<IconButton onClick={handleClick} sx={{ ml: rowNode.depth * 4 }}>
							{rowNode.childrenExpanded ? 
							<ArrowDown addClass='font-12'></ArrowDown>
								:
							<ArrowRight addClass='font-12'></ArrowRight>}
						</IconButton>{/* )} */}
						{rowNode.children.length > 1 ? `(${rowNode.children.length})` : ''} {rowNode.depth===0 ? props.row.SETTORE : props.row.CATEGORIA}
					</>
					:
						<span/>
				}
			</div>
		);
	}
  }

const getTreeDataPath: any = (row:any) => row.hierarchy;

const groupingColDef: DataGridPremiumProps['groupingColDef'] = {
	headerName: 'Settore / Categoria',
	width: 300,
	renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} />,
};

function ReportSettori(props:any) {

	const auth = useContext(AuthContext);
	const {userEmail,setPageName} = useContext(AppAuthGlobalVariables)

	const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState<GridRowModel[]>([]);
    const [talentManagers, setTalentManagers] = useState([]);
	const [referentiCommerciali, setReferentiCommerciali] = useState([]);
    const [anno, setAnno] = useState(new Date().getFullYear().toString());
    const [kTalentManager, setKTalentManager] = useState<any>('');
	const [kRefCommerciale, setKRefCommerciale] = useState<any>('');

	useEffect(() => {
        async function init(){
			await getUtenti();
			setPageName?.('Report - Settori');
        }
        init();
    },[]);

	useEffect(() => {
		async function init() {
			if(talentManagers.length!==0){
				if(anno.length===4){
					await getReport();
				}
			}
		}
		init();
	},[anno, kTalentManager, kRefCommerciale, talentManagers]);
	
	const getUtenti = async() => {
        try {    
			let axiosParams = {
				url		: 'users',
				method	: 'get',
				baseURL	: config.API_URL,
				headers	: {Authorization: `Bearer ${auth.sessionInfo?.accessToken}`}
			}
			let response = await axios(axiosParams);

			if (response.status === 200){
                let talentManagers = response.data.filter((tm:any) => tm.FLAG_TALENT_MANAGER === 'Y');
				let refCommerciali = response.data.filter((tm:any) => tm.FLAG_REF_COMM === 'Y');
				setTalentManagers(talentManagers);
				setReferentiCommerciali(refCommerciali);
			}

		} catch (e:any) {
			if(e.response.status===500){
                NotificationManager.error((typeof e.response.data.errorMessage === 'object' ? '' : e.response.data.errorMessage), 'Errore', 10000);
            }else if(e.response.status===401){
                NotificationManager.error('Non Autorizzato', 'Errore', 10000);
                props.logOut();
            }else{
                NotificationManager.error('Errore di Rete', 'Errore', 10000);
            }
		}
    }

	const getReport = async() => {
		try {
            let axiosParams = {
                url		: 'report-settori',
                method	: 'get',
                baseURL	: config.API_URL,
                headers	: {Authorization: `Bearer ${auth.sessionInfo?.accessToken}`},
                params: { 
					anno,
					kTalentManager,
					kReferenteCommerciale: kRefCommerciale
				}
            }

            let response = await axios(axiosParams);

            if (response.status === 200){
				const rows = response.data
				const data = rows.map((el:any,index:number) => {el.id = index; el.hierarchy = el.CLIENTE 
                                                                                ?
                                                                                [el.SETTORE, el.CATEGORIA, el.CLIENTE] 
                                                                                :
                                                                                el.CATEGORIA
                                                                                ?
                                                                                [el.SETTORE, el.CATEGORIA]
                                                                                :
                                                                                [el.SETTORE]; return el})
	        	setRows([...data]);

				setLoading(false);
            }
        } catch (e:any) {
			setLoading(false);
            if(e.response.status===500){
                NotificationManager.error((typeof e.response.data.errorMessage === 'object' ? '' : e.response.data.errorMessage), 'Errore', 10000);
            }else if(e.response.status===401){
                NotificationManager.error('Non Autorizzato', 'Errore', 10000);
                props.logOut();
            }else{
                NotificationManager.error('Errore di Rete', 'Errore', 10000);
            }
        }
	}
	
	return (
		<div className='component-container report-settori'>
			{loading && (<CircleProgress/>)}
			<div className='component-card'>
				<div className='report-wrapper'>
					<div className='filters-section'>
						<TextField 
							id="anno" 
							label="Anno" 
							variant="standard"
							value={anno}
							onChange={(event) => {if(inputOnlyNumbers(event.target.value))setAnno(event.target.value)}} 
							inputProps={{maxLength: 4}}
							sx={{maxWidth:'80px'}}
						/>
						<FormControl variant="standard" sx={{ m: 1, maxWidth: 300, width: '100%' }}>
							<InputLabel id="talentManagerLabel">Talent Manager</InputLabel>
							<Select
								labelId="talentManagerLabel"
								id="talentManager"
								value={kTalentManager}
								onChange={(event ) => setKTalentManager(event.target.value)}
								label="Talent Manager"
							>
								<MenuItem key={'0'} value={''}>Tutti</MenuItem>
								{talentManagers.map((tm:any) => <MenuItem key={tm.id} value={tm.id}>{tm.NOME} {tm.COGNOME}</MenuItem>)}
							</Select>
						</FormControl>
						<FormControl variant="standard" sx={{ m: 1, maxWidth: 300, width: '100%' }}>
							<InputLabel id="refCommercialeLabel">Referente Commerciale</InputLabel>
							<Select
								labelId="refCommercialeLabel"
								id="refCommerciale"
								value={kRefCommerciale}
								onChange={(event ) => setKRefCommerciale(event.target.value)}
								label="Referente Commerciale"
							>
								<MenuItem key={'0'} value={''}>Tutti</MenuItem>
								{referentiCommerciali.map((tm:any) => <MenuItem key={tm.id} value={tm.id}>{tm.NOME} {tm.COGNOME}</MenuItem>)}
							</Select>
						</FormControl>
					</div>
					<ThemeProvider theme={theme}>
						<DataGridPremium
							className='dataGrid'
							slots={{
								noRowsOverlay: NoRowsDataGridComponent,
								toolbar: CustomToolbar,
							}}
							treeData
							getTreeDataPath={getTreeDataPath}
							rows={rows}
							columns={columns}
							rowHeight={30}
							hideFooter={true}
							isCellEditable={(params) => params.id!==0}
							disableColumnMenu={false}
							disableColumnReorder={true}
							disableAggregation={true}
							disableColumnFilter={true}
							disableRowGrouping={true}
							groupingColDef={groupingColDef}
							getRowClassName={(params) => params.row.KSTATO === '06' ? 'red-row' : !params.id ? 'non-editable-row' : ''}
							pinnedRows={{bottom: [], top: [rows.length > 0 ? rows[0] : {id:0}]}}
							pinnedColumns={{left: [GRID_TREE_DATA_GROUPING_FIELD]}}
							unstable_ignoreValueFormatterDuringExport={{csvExport: true}}
						/>
					</ThemeProvider>
				</div>
			</div>
		</div>
	)
}

export default ReportSettori